<template>
    <div class="q-pa-md">
      <q-tabs align="left" v-model="activeTab">
        <q-tab :label="'ESET'+' ('+esetOrdersCount+')'" class="text-blue" name="ESET"/>
        <q-tab :label="'Fortinet'+' ('+fortinetOrdersCount+')'" class="text-blue" name="Fortinet"/>
      </q-tabs>
      <div class="position-absolute" style="right: 15px;top:75px;z-index: 1">
        <div class="d-flex">
          <!-- <q-btn label="EXPORT" class="pd-btn mr-1">
            <q-menu>
              <q-list>
                <q-item @click="exportRetailSales('2')" clickable v-close-popup>
                  <q-item-section>ESET</q-item-section>
                </q-item>
                <q-item @click="exportRetailSales('4')" clickable v-close-popup>
                  <q-item-section>FORTINET</q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn> -->
          <div @click="exportDialog = true" class="export-button mr-2">
            <q-tooltip>Export</q-tooltip> <div class="mt-1"><img alt="" src="../../assets/share.png"></div>
          </div>
          <!-- <q-btn @click="retailSalesDialog=true" class="pd-btn mr-2">ADD ESET</q-btn> -->
          <q-btn @click="retailSalesDialogFortinet=true" class="pd-btn mr-2">ADD FORTINET</q-btn>
          <q-input v-if="activeTab==='ESET'" class="searchBox" debounce="800" placeholder="Search" style="width: 300px"
                   v-model="esetFilter">
            <template v-slot:prepend>
              <q-icon name="search"/>
            </template>
          </q-input>
          <q-input v-if="activeTab==='Fortinet'" class="searchBox" debounce="800" placeholder="Search"
                   style="width: 300px" v-model="fortinetFilter">
            <template v-slot:prepend>
              <q-icon name="search"/>
            </template>
          </q-input>
        </div>
      </div>
      <q-dialog position="right" v-model="ESETDialog">
        <q-card v-if="ESETDialog" style="min-width: 1200px !important; min-height: 95vh;">
          <q-card-section>
            <div class="row">
              <div class="d-flex col-12 q-pa-md pt-0" style="justify-content: space-between; align-items: center ">
                <div><h4 style="font-size: 22px; font-weight: 300;"> Retail Sales Details </h4></div>
                <div class="drawerButtons d-flex mr-3" style="margin-top: -10px;">
                  <q-btn flat round @click.stop="onEditRetailSalesOrder(selectedOrderObj,activeTab)">
                    <q-tooltip>Edit Order</q-tooltip>
                    <i class="material-icons" style="font-size: 16px;color: #777777;margin-right: 5px">edit</i>
                  </q-btn>
                  <q-btn @click="ESETDialog=false" flat icon="close" round size="small"></q-btn>
                </div>
              </div>
              <div class="col-4 q-pa-md" style="border-right: 1px solid lightgray">
                <ul style="list-style: none">
                  <li class="pb-3" style="border-bottom: 1px solid #e0e0e0"></li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Order ID</span>
                    <h4 style="font-size: 24px; font-weight: 400">
                      {{ selectedOrderObj.orderNum ? selectedOrderObj.orderNum : '-' }}</h4>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Placed By</span>
                    <span>{{ selectedOrderObj.PlacedBy ? selectedOrderObj.PlacedBy.name : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Customer Name</span>
                    <span>{{ selectedOrderObj.ToCustomer ? selectedOrderObj.ToCustomer.name : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Company Name</span>
                    <span>{{ (selectedOrderObj.ToCustomer && selectedOrderObj.ToCustomer.companyName) ||  '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Customer Mobile</span>
                    <span>{{ selectedOrderObj.ToCustomer ? selectedOrderObj.ToCustomer.mobile : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Customer Email</span>
                    <span>{{ selectedOrderObj.ToCustomer ? selectedOrderObj.ToCustomer.email : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Invoice No</span>
                    <span>{{ selectedOrderObj.invoiceNumber ? selectedOrderObj.invoiceNumber : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Invoice Date</span>
                    <span>{{ selectedOrderObj.invoiceDate ? dateFilter(selectedOrderObj.invoiceDate) : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Activation Date</span>
                    <span>{{ selectedOrderObj.date ? dateFilter(selectedOrderObj.date) : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Created On</span>
                    <span>{{ selectedOrderObj.createdOn ? dateTimeFilter(selectedOrderObj.createdOn) : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                    <span class="bankLabel d-block">Invoice Note</span>
                    <span>{{ selectedOrderObj.invoiceNote ? selectedOrderObj.invoiceNote : '-' }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-8 q-pa-md" style="height: 80vh; overflow-y: auto">
                <h6 style="margin-top: -18px;margin-bottom: 10px;">Total Items :
                  {{
                    selectedOrderObj.OrderItems_aggregate ? selectedOrderObj.OrderItems_aggregate.aggregate.count : 0
                  }}</h6>
                <div v-show="batch_loader">
                  <q-inner-loading :showing="true" style="top: 200px;width: 430px;height: 40px;left: 450px;">
                    <q-spinner-dots color="primary" size="50px"></q-spinner-dots>
                  </q-inner-loading>
                </div>
                <template v-if="productArr && productArr.length">
                  <template v-for="(product, index) in productArr">
                    <template v-if="product.OrderItems.length">
                      <q-card class="product-card mb-3" v-for="(orderItem, i) in product.OrderItems" :key="'serial-'+index+i">
                        <q-card-section>
                          <div class="mp-card">
                            <div class="mp-header">
                              <div class="d-flex justify-content-between" style="align-items: center">
                                <div class="d-flex">
                                  <div class="text-left mr-5">
                                    <span class="bankLabel">Serial</span>
                                    <h4 style="font-size: 22px; line-height: 1.5rem; font-weight: 300; ">{{orderItem.ProductInventory.serial}}</h4>
                                  </div>
                                  <div class="ml-5 text-left">
                                    <span class="bankLabel">Product</span>
                                    <h4 style="font-size: 16px; line-height: 1.5rem; font-weight: 100; ">{{product.name}}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr class="my-2" style="border: 0.5px solid lightgray">
  
                            <div class="mp-body">
                              <ul style="list-style: none">
                                <div class="d-flex justify-content-between" style="align-items: center">
                                  <div class="d-flex py-3">
                                    <li>
                                      <div>
                                        <span class="bankLabel">Activation Date</span>
                                        <div class="mp-value">
                                          <span>{{orderItem.meta.activationDate}}</span>
                                        </div>
                                      </div>
                                    </li>
                                    <li style="margin-left: 70px;">
                                      <div>
                                        <span class="bankLabel">Expiry Date</span>
                                        <div class="mp-value">
                                          <span>{{orderItem.meta.expiryDate}}</span>
                                        </div>
                                      </div>
                                    </li>
                                    <li style="margin-left: 70px;">
                                      <div>
                                        <span class="bankLabel">Product Key</span>
                                        <div class="mp-value">
                                          <span>{{ orderItem.meta.productKey || '-' }}</span>
                                        </div>
                                      </div>
                                    </li>
                                  </div>
  
                                </div>
  
                              </ul>
  
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>
                    </template>
                  </template>
                </template>
                <!-- <q-list bordered class="rounded-borders" v-if="productArr && productArr.length">
                   <template v-for="(product, index) in productArr" v-if="product.OrderItems.length">
                     <q-expansion-item>
                       <template slot="header">
                         <q-item-section> {{ product.name }}</q-item-section>
                         <q-item-section side>{{ product.OrderItems.length }}</q-item-section>
                       </template>
                       <q-card>
                         <q-card-section>
                           <q-list bordered padding>
                             <q-item :key="i" tag="label" v-for="(orderItem, i) in product.OrderItems">
                               <q-item-section side top></q-item-section>
                               <q-item-section>
                                 <q-item-label>{{ orderItem.ProductInventory.serial }}
                                   <span style="float:right;"></span>
                                 </q-item-label>
                                 <q-item-label caption>
                                   <span>Activation-date: {{
                                       dynamicDateFormatter(orderItem.meta.activationDate, 'DD-MM-YYYY', 'DD/MM/YYYY')
                                     }} | </span>
                                   <span>Expiry-date: {{
                                       dynamicDateFormatter(orderItem.meta.expiryDate, 'DD-MM-YYYY', 'DD/MM/YYYY')
                                     }} </span>
                                   <span
                                       v-if="orderItem.meta.productKey"> | Product-key: {{
                                       orderItem.meta.productKey
                                     }}</span>
                                 </q-item-label>
                               </q-item-section>
                             </q-item>
                           </q-list>
                         </q-card-section>
                       </q-card>
                     </q-expansion-item>
                   </template>
                 </q-list> -->
              </div>
            </div>
          </q-card-section>
        </q-card>
      </q-dialog>
      <q-dialog position="right" v-model="FortinetDialog">
        <q-card v-if="FortinetDialog" style="min-width: 1200px !important;">
          <q-card-section>
            <div class="row">
              <div class="d-flex col-12 q-pa-md pt-0" style="justify-content: space-between; align-items: center ">
                <div><h4 style="font-size: 22px; font-weight: 300;">Retail Sales Details</h4></div>
                <div class="drawerButtons mr-1" style="margin-top: -10px;">
                  <q-btn @click="FortinetDialog=false" flat icon="close" round size="small"></q-btn>
                </div>
              </div>
              <div v-if="selectedOrderObj" class="col-12 q-pa-sm ml-2 mr-3 d-flex justify-between"
                   style="border: 1px solid dodgerblue; border-radius: 5px;align-items: center">
                <div>
                  <div class="text-weight-bold">
                    {{ selectedOrderObj.OrderItems.length && selectedOrderObj.OrderItems[0].SupportPlans.length 
                      ? selectedOrderObj.OrderItems[0].SupportPlans[0].serialNo 
                      : '' }}
                  </div>
                  <div>
                    {{ selectedOrderObj.OrderItems.length && selectedOrderObj.OrderItems[0].SupportPlans.length 
                      ? selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.name 
                      : '' }}
                  </div>
                </div>
                <div>
                  <div
                    class="ExpiredSupportPlanLabel"
                    v-if="
                      selectedOrderObj.OrderItems.length &&
                      selectedOrderObj.OrderItems[0].SupportPlans.length &&
                      getSupportPlanStatus(selectedOrderObj.OrderItems[0].SupportPlans[0].endDate).expired
                    "
                  >
                    Expired
                  </div>
                  <div class="ActiveSupportPlanLabel" v-else>Active</div>
                </div>
              </div>
              <div class="col-4 q-pa-md">
                <q-card bordered flat class="p-3 position-relative" v-if="selectedOrderObj">
                  <q-btn @click="onEditRetailSalesOrder(selectedOrderObj,activeTab)"
                         style="position: absolute; top: -14px; right: -14px;" class="theme-color-2 text-white" flat
                         icon="edit" round size="12px"></q-btn>
                  <h6>Product Details</h6>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Name</span>
                    <span>
                      {{
                        selectedOrderObj.OrderItems.length &&
                        selectedOrderObj.OrderItems[0].SupportPlans.length &&
                        selectedOrderObj.OrderItems[0].SupportPlans[0].Product
                          ? selectedOrderObj.OrderItems[0].SupportPlans[0].Product.name
                          : ''
                      }}
                    </span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Serial</span>
                    <span>
                      {{
                        selectedOrderObj.OrderItems.length &&
                        selectedOrderObj.OrderItems[0].SupportPlans.length 
                          ? selectedOrderObj.OrderItems[0].SupportPlans[0].serialNo
                          : ''
                      }}
                    </span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Activation Date</span>
                    <span>{{
                        dynamicDateFormatter(selectedOrderObj.OrderItems[0].meta.activationDate, 'DD-MM-YYYY',
                            'DD/MM/YYYY')
                      }}</span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Expiry Date</span>
                    <span>{{
                        dynamicDateFormatter(selectedOrderObj.OrderItems[0].meta.expiryDate, 'DD-MM-YYYY', 'DD/MM/YYYY')
                      }}</span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Product Key</span>
                    <span>{{ checkVal(selectedOrderObj.OrderItems[0].meta.productKey) }}</span>
                  </div>
                  <q-separator style="margin-top: 30px;  margin-bottom: 30px;"></q-separator>
                  <h6>Customer Details</h6>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Name</span>
                    <span>{{ selectedOrderObj.ToCustomer ? checkVal(selectedOrderObj.ToCustomer.name) : '-' }}</span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Company Name</span>
                    <span>{{
                        selectedOrderObj.ToCustomer ? checkVal(selectedOrderObj.ToCustomer.companyName) : '-'
                      }}</span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Email</span>
                    <span>{{ selectedOrderObj.ToCustomer ? checkVal(selectedOrderObj.ToCustomer.email) : '-' }}</span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Mobile</span>
                    <span>{{ selectedOrderObj.ToCustomer ? checkVal(selectedOrderObj.ToCustomer.mobile) : '-' }}</span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">Phone</span>
                    <span>{{ selectedOrderObj.ToCustomer ? checkVal(selectedOrderObj.ToCustomer.phone) : '-' }}</span>
                  </div>
                  <div class="d-flex justify-between">
                    <span class="text-grey d-block mr-3">City</span>
                    <span>{{ selectedOrderObj.ToCustomer ? checkVal(selectedOrderObj.ToCustomer.city) : '-' }}</span>
                  </div>
                </q-card>
              </div>
              <div class="col-8  py-3">
                <div class="row">
                  <div class="col-12 ">
                    <q-card bordered flat class="p-3 position-relative">
                      <h6>Order Details</h6>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Order ID</span>
                        <span>{{ selectedOrderObj.orderNum ? checkVal(selectedOrderObj.orderNum) : '-' }}</span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Placed By</span>
                        <span>{{ selectedOrderObj.PlacedBy ? selectedOrderObj.PlacedBy.name : '-' }}</span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Invoice Date</span>
                        <span>{{ selectedOrderObj.invoiceDate ? dateFilter(selectedOrderObj.invoiceDate) : '-' }}</span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Invoice No</span>
                        <span>{{ selectedOrderObj.invoiceNumber ? checkVal(selectedOrderObj.invoiceNumber) : '-' }}</span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Order Date</span>
                        <span>{{ selectedOrderObj.date ? dateFilter(selectedOrderObj.date) : '-' }}</span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Created On</span>
                        <span>{{ selectedOrderObj.createdOn ? dateTimeFilter(selectedOrderObj.createdOn) : '-' }}</span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Invoice Note</span>
                        <span>{{ selectedOrderObj.invoiceNote ? selectedOrderObj.invoiceNote : '-' }}</span>
                      </div>
                    </q-card>
                  </div>
                  <div class="col-6 pr-1 ">
                    <q-card bordered flat class="p-3 position-relative mt-2">
                      <h6>Original Partner</h6>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Partner Name</span>
                        <span>{{ selectedOrderObj.FromOrganization.name }}</span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Partner Code</span>
                        <span>{{ selectedOrderObj.FromOrganization.partnerCode }}</span>
                      </div>
                      <template v-if="selectedOrderObj.FromOrganization.id===AIPL_ORGID">
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">User Name</span>
                          <span>Upendra Makwana</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Mobile</span>
                          <span>8980012210</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Email</span>
                          <span>upendra.makwana@amitygroup.in</span>
                        </div>
                      </template>
                      <template v-else-if="selectedOrderObj.FromOrganization.Users.length">
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">User Name</span>
                          <span>{{ selectedOrderObj.FromOrganization.Users[0].name }}</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Mobile</span>
                          <span>{{ selectedOrderObj.FromOrganization.Users[0].mobile }}</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Email</span>
                          <span>{{ selectedOrderObj.FromOrganization.Users[0].email }}</span>
                        </div>
                      </template>
                    </q-card>
                  </div>
                  <div class="col-6 pl-1">
                    <q-card bordered flat class="p-3 position-relative mt-2">
                      <h6>Current Partner</h6>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Partner Name</span>
                        <span>
                          {{
                            selectedOrderObj.OrderItems.length &&
                            selectedOrderObj.OrderItems[0].SupportPlans.length &&
                            selectedOrderObj.OrderItems[0].SupportPlans[0].Partner
                              ? selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.name
                              : ''
                          }}
                        </span>
                      </div>
                      <div class="d-flex justify-between">
                        <span class="text-grey d-block mr-3">Partner Code</span>
                        <span>
                          {{
                            selectedOrderObj.OrderItems.length &&
                            selectedOrderObj.OrderItems[0].SupportPlans.length &&
                            selectedOrderObj.OrderItems[0].SupportPlans[0].Partner
                              ? selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.partnerCode
                              : ''
                          }}
                        </span>
                      </div>
                      <template v-if="selectedOrderObj.OrderItems.length && selectedOrderObj.OrderItems[0].SupportPlans.length && selectedOrderObj.OrderItems[0].SupportPlans[0].Partner && selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.id===AIPL_ORGID">
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">User Name</span>
                          <span>Upendra Makwana</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Mobile</span>
                          <span>8980012210</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Email</span>
                          <span>upendra.makwana@amitygroup.in</span>
                        </div>
                      </template>
                      <template v-else-if="selectedOrderObj.OrderItems.length && selectedOrderObj.OrderItems[0].SupportPlans.length && selectedOrderObj.OrderItems[0].SupportPlans[0].Partner && selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.Users && selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.Users.length">
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">User Name</span>
                          <span>{{ selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.Users[0].name }}</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Mobile</span>
                          <span>{{ selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.Users[0].mobile }}</span>
                        </div>
                        <div class="d-flex justify-between">
                          <span class="text-grey d-block mr-3">Email</span>
                          <span>{{ selectedOrderObj.OrderItems[0].SupportPlans[0].Partner.Users[0].email }}</span>
                        </div>
                      </template>
                    </q-card>
                  </div>
                </div>
              </div>
              <q-separator></q-separator>
              <div class="col-12 q-pa-md" style="overflow-y: auto">
                <div v-show="batch_loader">
                  <q-inner-loading :showing="true" style="top: 200px;width: 430px;height: 40px;left: 450px;">
                    <q-spinner-dots color="primary" size="50px"></q-spinner-dots>
                  </q-inner-loading>
                </div>
                <div class="row mb-4">
                  <div class="col-12 text-h6">Support Plans</div>
                </div>
                <div :class="getSupportPlanStatus(supportPlan.endDate).class" class="mt-1"
                     v-for="(supportPlan,index) in selectedOrderObj.OrderItems[0].SupportPlans" :key="index">
                  <div class="row q-pa-md">
                    <div class="col">
                      <span class="bankLabel">Support Pack</span>
                      <div>{{ supportPlan.SupportPlan.name }}</div>
                    </div>
                    <div class="col">
                      <span class="bankLabel">Since</span>
                      <div>{{ dateMonthFilter(supportPlan.startDate) }}</div>
                    </div>
                    <div class="col">
                      <span class="bankLabel">Till</span>
                      <div>{{ dateMonthFilter(supportPlan.endDate) }}</div>
                    </div>
                    <div class="col">
                      <span class="bankLabel">Partner</span>
                      <div>{{ supportPlan.Partner.name }}</div>
                    </div>
                    <div class="col">
                      <span class="bankLabel">Created On</span>
                      <div>{{ dateFilter(supportPlan.created_at) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </q-dialog>
      <q-dialog content-class="my-special-class" persistent position="right" v-model="retailSalesDialog">
        <retail-sales @closeRetailSalesDialog="retailSalesDialog=false" ref="place-retail-sales"/>
      </q-dialog>
      <q-dialog content-class="my-special-class" persistent position="right" v-model="retailSalesDialogFortinet">
        <RetailSalesFortinet @closeRetailSalesDialog="retailSalesDialogFortinet=false"
                             ref="place-retail-sales-fortinet"></RetailSalesFortinet>
      </q-dialog>
      <div v-if="activeTab==='ESET'">
        <q-table :pagination-label="getESETPaginationLabel" :loading="esetOrderLoader"
                 @request="updatePagination('',$event)" :columns="ESETColumns" :pagination.sync="paginationESET"
                 :data="esetOrders" class="table-header" flat table-class="table-class" v-show="activeTab==='ESET'"
                 binary-state-sort :rows-per-page-options="[]">
          <template v-slot:body="props">
            <q-tr style="height: 5px"></q-tr>
            <q-tr @click.native="openOrderDetail(props.row,activeTab)" :props="props" class="tableItems">
              <q-td :props="props" key="orderId">
                {{ props.row.orderNum ? '#' + props.row.orderNum : '-' }}
              </q-td>
              <q-td :props="props" key="placedBy">
                {{ props.row.PlacedBy ? props.row.PlacedBy.name : '-' }}
              </q-td>
              <q-td :props="props" key="customerMobile">
                {{ props.row.ToCustomer ? props.row.ToCustomer.mobile : '-' }}
              </q-td>
              <q-td :props="props" key="customerEmail">
                {{ props.row.ToCustomer ? props.row.ToCustomer.email : '-' }}
              </q-td>
              <q-td :props="props" key="orderFrom">
                {{ props.row.FromOrganization ? props.row.FromOrganization.name : '-' }}
              </q-td>
              <q-td :props="props" key="orderTo">
                {{ props.row.ToCustomer ? props.row.ToCustomer.name : '-' }}
              </q-td>
              <q-td :props="props" key="date">
                {{ props.row.date ? dateFilter(props.row.date) : '-' }}
              </q-td>
              <q-td :props="props" key="createdOn">
                {{ props.row.createdOn ? dateTimeFilter(props.row.createdOn) : '-' }}
              </q-td>
              <q-td :props="props" key="invoiceNo">
                {{ props.row.invoiceNumber ? props.row.invoiceNumber : '-' }}
              </q-td>
              <q-td :props="props" key="invoiceDate">
                {{ props.row.invoiceDate ? dateFilter(props.row.invoiceDate) : '-' }}
              </q-td>
              <q-td :props="props" key="itemCount">
                {{ props.row.OrderItems_aggregate.aggregate.count }}
              </q-td>
            </q-tr>
          </template>
          <template v-slot:no-data="{ icon, message, filter }">
            <div class="full-width row flex-center q-gutter-sm">
              <div>
                <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
                <h6 class="text-center">No data available</h6>
              </div>
            </div>
          </template>
          <template v-slot:pagination="scope">
            <div class="mt-2">{{ getESETPaginationLabel() }}</div>
            <q-btn icon="chevron_left" color="grey-8" round dense flat :disable="paginationESET.offset===0"
                   @click="updatePagination('subtract')"/>
            <q-btn icon="chevron_right" color="grey-8" round dense flat
                   :disable="(paginationESET.offset+paginationESET.limit)>paginationESET.rowsNumber"
                   @click="updatePagination('add')"/>
          </template>
        </q-table>
      </div>
      <div v-if="activeTab==='Fortinet'">
        <q-table :pagination-label="getFortinetPaginationLabel" :loading="fortinetOrderLoader"
                 @request="updatePagination('',$event)" :columns="FortinetColumns" :data="fortinetOrders"
                 class="table-header" flat :rows-per-page-options="[]" :pagination.sync="paginationFortinet"
                 binary-state-sort table-class="table-class" v-show="activeTab==='Fortinet'">
          <template v-slot:body="props">
            <q-tr style="height: 5px"></q-tr>
            <q-tr @click.native="openOrderDetail(props.row,activeTab)" :props="props" class="tableItems">
              <q-td :props="props" key="orderId">
                {{ props.row.orderNum ? '#' + props.row.orderNum : '-' }}
              </q-td>
              <q-td :props="props" key="date">
                {{ props.row.date ? dateFilter(props.row.date) : '-' }}
              </q-td>
              <q-td :props="props" key="expiryDate">
                {{
                  props.row.OrderItems.length ? dynamicDateFormatter(props.row.OrderItems[0].meta.expiryDate,
                      'DD-MM-YYYY', 'DD/MM/YYYY') : '-'
                }}
              </q-td>
              <q-td :props="props" key="endDate">
                {{ 
                  props.row.OrderItems.length && props.row.OrderItems[0].SupportPlans.length
                    ? dateFilter(props.row.OrderItems[0].SupportPlans[0].endDate)
                    : '-' 
                }}
              </q-td>
              <q-td :props="props" key="productSKU">
                {{ 
                  props.row.OrderItems.length && props.row.OrderItems[0].SupportPlans.length
                    ? props.row.OrderItems[0].SupportPlans[0].Product.sku
                    : '-' 
                }}
              </q-td>
              <q-td :props="props" key="serialNo">
                {{ 
                  props.row.OrderItems.length && props.row.OrderItems[0].SupportPlans.length
                    ? props.row.OrderItems[0].SupportPlans[0].serialNo
                    : '-' 
                }}
              </q-td>
              <q-td :props="props" key="customerCompanyName">
                {{ props.row.ToCustomer ? checkVal(props.row.ToCustomer.companyName) : '-' }}
              </q-td>
              <q-td :props="props" key="customerName">
                {{ props.row.ToCustomer ? checkVal(props.row.ToCustomer.name) : '-' }}
              </q-td>
              <q-td :props="props" key="customerMobile">
                {{ props.row.ToCustomer ? checkVal(props.row.ToCustomer.mobile) : '-' }}
              </q-td>
              <q-td :props="props" key="customerPhone">
                {{ props.row.ToCustomer ? checkVal(props.row.ToCustomer.phone) : '-' }}
              </q-td>
              <q-td :props="props" key="customerEmail">
                {{ props.row.ToCustomer ? checkVal(props.row.ToCustomer.email) : '-' }}
              </q-td>
              <q-td :props="props" key="customerCity">
                {{ props.row.ToCustomer ? checkVal(props.row.ToCustomer.city) : '-' }}
              </q-td>
              <q-td :props="props" key="originalPartner">
                {{ props.row.FromOrganization ? props.row.FromOrganization.name : '-' }}
              </q-td>
              <q-td :props="props" key="currentPartner">
                {{ 
                  props.row.OrderItems.length && props.row.OrderItems[0].SupportPlans.length
                    ? props.row.OrderItems[0].SupportPlans[0].Partner.name
                    : '-' 
                }}
              </q-td>
            </q-tr>
          </template>
          <template v-slot:no-data="{ icon, message, filter }">
            <div class="full-width row flex-center q-gutter-sm">
              <div>
                <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
                <h6 class="text-center">No data available</h6>
              </div>
            </div>
          </template>
          <template v-slot:pagination="scope">
            <div class="mt-2">{{ getFortinetPaginationLabel() }}</div>
            <q-btn icon="chevron_left" color="grey-8" round dense flat
                   :disable="paginationFortinet.offset===0" @click="updatePagination('subtract')"/>
            <q-btn icon="chevron_right" color="grey-8" round dense flat
                   :disable="(paginationFortinet.offset+paginationFortinet.limit)>paginationFortinet.rowsNumber"
                   @click="updatePagination('add')"/>
          </template>
        </q-table>
      </div>
      <q-dialog content-class="my-special-class" persistent position="right" v-model="updateRS_ESET_Dialog">
        <UpdateRetailSales :orgId="userObj.orgId" @closeUpdateRSDialog="updateRS_ESET_Dialog=false"
                           ref="update-retail-sales"/>
      </q-dialog>
      <q-dialog content-class="my-special-class" persistent position="right" v-model="updateRS_Fortinet_Dialog">
        <UpdateRetailSalesFortinet :orgId="userObj.orgId" @closeUpdateRSDialog="updateRS_Fortinet_Dialog=false"
                                   ref="update-retail-sales-fortinet"></UpdateRetailSalesFortinet>
      </q-dialog>
      <export-retail-sales :exportDialog.sync="exportDialog"/>
    </div>
  </template>
  
  <script>
  import { GET_ORDER_SKU_GROUPBY_PRODUCT } from '@/graphql/queries/Orders'
  import RetailSales from '../RetailSales/RetailSales'
  import {
    SUBSCRIBE_RETAIL_FORTINET_ORDERS_TOTAL_COUNT,
    SUBSCRIBE_RETAIL_ORDERS_TOTALCOUNT, SUBSCRIBE_RETAIL_SALES_FORTINET_ORDERS, SUBSCRIBE_RETAIL_SALES_ORDERS,
  } from '@/graphql/subscription/Orders'
  import UpdateRetailSales from '../RetailSales/UpdateRetailSales'
  import RetailSalesFortinet from '@/components/RetailSales/RetailSalesFortinet'
  import moment from 'moment'
  import UpdateRetailSalesFortinet from '@/components/RetailSales/UpdateRetailSalesFortinet'
  import Constants from '@/Constants/Constant'
  import ExportRetailSales from "../RetailSales/ExportRetailSales";
  
  export default {
    components: {ExportRetailSales ,UpdateRetailSales, RetailSales, RetailSalesFortinet, UpdateRetailSalesFortinet },
    apollo: {
      $subscribe: {
        esetOrdersCount: {
          query: SUBSCRIBE_RETAIL_ORDERS_TOTALCOUNT,
          variables () {
            return {
              filter: this.combineESETFilter, orgId: this.userObj.orgId, status: 'Sold',
            }
          },
          result ({ data }) {
            this.esetOrdersCount = data.esetOrdersCount.aggregate.count
            this.paginationESET.rowsNumber = this.esetOrdersCount
            this.$forceUpdate()
            this.$emit('esetOrdersCount', this.esetOrdersCount)
          },
        },
        fortinetOrdersCount: {
          query: SUBSCRIBE_RETAIL_FORTINET_ORDERS_TOTAL_COUNT,
          variables () {
            return {
              filter: this.combineFortinetFilter, orgId: this.userObj.orgId, status: 'Sold',
            }
          },
          result ({ data }) {
            this.fortinetOrdersCount = data.fortinetOrdersCount.aggregate.count
            this.paginationFortinet.rowsNumber = this.fortinetOrdersCount
            this.$forceUpdate()
            this.$emit('fortinetOrdersCount', this.fortinetOrdersCount)
          },
        },
        esetOrders: {
          query: SUBSCRIBE_RETAIL_SALES_ORDERS,
          fetchPolicy: 'network-only',
          variables () {
            return {
              sortObj: this.paginationESET.sortObj,
              orgId: this.userObj.orgId, offset: this.paginationESET.offset,
              limit: this.paginationESET.limit, filter: this.combineESETFilter,
            }
          },
          result ({ data }) {
            this.esetOrders = data.esetOrders
            this.esetOrderLoader = false
          },
        },
        FortinetOrders: {
          query: SUBSCRIBE_RETAIL_SALES_FORTINET_ORDERS,
          variables () {
            return {
              sortObj: this.paginationFortinet.sortObj,
              sortSupportObj: this.paginationFortinet.sortSupportObj,
              orgId: this.userObj.orgId, offset: this.paginationFortinet.offset,
              limit: this.paginationFortinet.limit, filter: this.combineFortinetFilter,
            }
          },
          result ({ data }) {
            this.fortinetOrders = data.FortinetOrders
            this.fortinetOrderLoader = false
          },
        },
      },
    },
    name: 'RetailSalesVAPOffline',
    data: function () {
      return {
        AIPL_ORGID: Constants.AIPL_ORGID,
        userObj: JSON.parse(localStorage.getItem('user')),
        ESETDialog: false, FortinetDialog: false,
        esetOrders: [], fortinetOrders: [], productArr: [],
        selectedOrderObj: '',
        esetOrderLoader: true, fortinetOrderLoader: true, batch_loader: false,      //For orderDetail dialog
        esetOrdersCount: 10, fortinetOrdersCount: 10,
        esetFilter: '', fortinetFilter: '', combineESETFilter: '%%', combineFortinetFilter: '%%',
        activeTab: 'ESET',
        paginationESET: {
          rowsPerPage: 50, rowsNumber: 0, limit: 50, offset: 0,
          sortBy: 'createdOn', orderBy: 'desc_nulls_last', sortObj: {},
        },
        paginationFortinet: {
          rowsPerPage: 50, rowsNumber: 0, limit: 50, offset: 0,
          sortBy: 'createdOn', orderBy: 'desc_nulls_last',
          sortObj: {}, sortSupportObj: {},
        },
        retailSalesDialog: false, retailSalesDialogFortinet: false, addNewSupportPlanDialog: false,
        updateRS_ESET_Dialog: false, updateRS_Fortinet_Dialog: false,
        ESETColumns: [
          { name: 'orderId', label: 'Order ID', field: 'orderId', align: 'left', sortable: false },
          { name: 'placedBy', label: 'Placed By', field: 'placedBy', align: 'left', sortable: false },
          { name: 'customerMobile', label: 'Mobile', field: 'customerMobile', align: 'left', sortable: false },
          { name: 'customerEmail', label: 'Email', field: 'customerEmail', align: 'left', sortable: false },
          { name: 'orderFrom', label: 'Order From', field: 'orderFrom', align: 'left', sortable: false },
          { name: 'orderTo', label: 'Order To', field: 'orderTo', align: 'left', sortable: false },
          { name: 'date', label: 'Activation Date', field: 'date', align: 'left', sortable: true },
          { name: 'createdOn', label: 'Created On', field: 'createdOn', align: 'left', sortable: true },
          { name: 'invoiceNo', label: 'Invoice No', field: 'invoiceNo', align: 'left', sortable: false },
          { name: 'invoiceDate', label: 'Invoice Date', field: 'invoiceDate', align: 'left', sortable: true },
          { name: 'itemCount', label: 'Items', field: 'itemCount', align: 'left', sortable: false },
        ],
        FortinetColumns: [
          { name: 'orderId', label: 'Order ID', field: 'orderId', align: 'left', sortable: false },
          { name: 'date', label: 'Order Date', field: 'date', align: 'left', sortable: true },
          { name: 'expiryDate', label: 'Product Expiry', field: 'expiryDate', align: 'left', sortable: false },
          { name: 'endDate', label: 'Support Expiry', field: 'endDate', align: 'left', sortable: true },
          { name: 'productSKU', label: 'SKU', field: 'productSKU', align: 'left', sortable: false },
          { name: 'serialNo', label: 'Serial', field: 'serialNo', align: 'left', sortable: false },
          {
            name: 'customerCompanyName', label: 'Customer Company Name',
            field: 'customerCompanyName', align: 'left', sortable: false,
          },
          { name: 'customerName', label: 'Contact Person', field: 'customerName', align: 'left', sortable: false },
          { name: 'customerMobile', label: 'Mobile', field: 'customerMobile', align: 'left', sortable: false },
          { name: 'customerPhone', label: 'Phone', field: 'customerPhone', align: 'left', sortable: false },
          { name: 'customerEmail', label: 'Email', field: 'customerEmail', align: 'left', sortable: false },
          { name: 'customerCity', label: 'City', field: 'customerCity', align: 'left', sortable: false },
          {
            name: 'originalPartner', label: 'Original Partner', field: 'originalPartner', align: 'left', sortable: false,
          },
          { name: 'currentPartner', label: 'Current Partner', field: 'currentPartner', align: 'left', sortable: false },
        ],
        exportDialog: false
      }
    },
    watch: {
      'esetFilter': function (val) {
        this.esetOrders = []
        this.esetOrderLoader = true
        this.combineESETFilter = '%' + val + '%'
      },
      'fortinetFilter': function (val) {
        this.fortinetOrders = []
        this.fortinetOrderLoader = true
        this.combineFortinetFilter = '%' + val + '%'
      },
    },
    methods: {
      updatePagination (operation, requestProp) {
        if (operation === 'add') {
          if (this.activeTab === 'ESET') {
            if (this.paginationESET.rowsNumber > (this.paginationESET.limit + this.paginationESET.offset)) {
              this.esetOrderLoader = true
              this.paginationESET.offset = this.paginationESET.limit + this.paginationESET.offset
            }
          } else if (this.activeTab === 'Fortinet') {
            if (this.paginationFortinet.rowsNumber > (this.paginationFortinet.limit + this.paginationFortinet.offset)) {
              this.fortinetOrderLoader = true
              this.paginationFortinet.offset = this.paginationFortinet.limit + this.paginationFortinet.offset
            }
          }
        } else if (operation === 'subtract') {
          if (this.activeTab === 'ESET') {
            if (0 !== this.paginationESET.offset) {
              this.esetOrderLoader = true
              this.paginationESET.offset = this.paginationESET.offset - this.paginationESET.limit
            }
          } else if (this.activeTab === 'Fortinet') {
            if (0 !== this.paginationFortinet.offset) {
              this.fortinetOrderLoader = true
              this.paginationFortinet.offset = this.paginationFortinet.offset - this.paginationFortinet.limit
            }
          }
        }
        if (requestProp) {
          let sortKey = requestProp.pagination.sortBy
          if (this.activeTab === 'ESET') {
            this.esetOrderLoader = true
            this.paginationESET.offset = 0
            this.paginationESET.orderBy = this.paginationESET.orderBy === 'desc_nulls_last'
                ? 'asc_nulls_last'
                : 'desc_nulls_last'
            this.paginationESET.sortObj = {}
            this.paginationESET.sortBy = sortKey
            this.paginationESET.sortObj[this.paginationESET.sortBy] = this.paginationESET.orderBy
          } else if (this.activeTab === 'Fortinet') {
            this.fortinetOrderLoader = true
            this.paginationFortinet.offset = 0
            this.paginationFortinet.orderBy = this.paginationFortinet.orderBy === 'desc_nulls_last'
                ? 'asc_nulls_last'
                : 'desc_nulls_last'
            this.paginationFortinet.sortObj = {}
            this.paginationFortinet.sortSupportObj = {}
            this.paginationFortinet.sortBy = sortKey
            if (sortKey === 'date')
              this.paginationFortinet.sortObj[this.paginationFortinet.sortBy] = this.paginationFortinet.orderBy
            else if (sortKey === 'endDate')
              this.paginationFortinet.sortSupportObj[this.paginationFortinet.sortBy] = this.paginationFortinet.orderBy
          }
        }
      },
      getESETPaginationLabel () {
        let start, end
        start = this.paginationESET.offset + 1
        if (this.paginationESET.offset > 0) {
          if ((this.paginationESET.limit + this.paginationESET.offset) > this.paginationESET.rowsNumber)
            end = this.paginationESET.rowsNumber
          else
            end = this.paginationESET.offset + this.paginationESET.limit
        } else if (this.paginationESET.offset === 0) {
          end = this.paginationESET.limit
        }
        return `${start}-${end} of ${this.paginationESET.rowsNumber}`
      },
      getFortinetPaginationLabel () {
        let start, end
        start = this.paginationFortinet.offset + 1
        if (this.paginationFortinet.offset > 0) {
          if ((this.paginationFortinet.limit + this.paginationFortinet.offset) > this.paginationFortinet.rowsNumber)
            end = this.paginationFortinet.rowsNumber
          else
            end = this.paginationFortinet.offset + this.paginationFortinet.limit
        } else if (this.paginationFortinet.offset === 0) {
          end = this.paginationFortinet.limit
        }
        return `${start}-${end} of ${this.paginationFortinet.rowsNumber}`
      },
      onEditRetailSalesOrder (order, activeTab) {
        if (activeTab === 'ESET') {
          this.updateRS_ESET_Dialog = true
          setTimeout(() => {
            this.$refs['update-retail-sales'].assignValues(order)
          }, 100)
          this.ESETDialog = false
        } else if (activeTab === 'Fortinet') {
          this.updateRS_Fortinet_Dialog = true
          setTimeout(() => {
            this.$refs['update-retail-sales-fortinet'].assignValues(order)
          }, 100)
          this.FortinetDialog = false
        }
      },
      openOrderDetail (order, activeTab) {
        this.selectedOrderObj = order
        this.productArr = []
        this.batch_loader = true
        activeTab === 'ESET' ? this.ESETDialog = true : this.FortinetDialog = true
        setTimeout(() => {
          this.getOrderSkuGroupByProduct(order.id)
        }, 400)
      },
      async getOrderSkuGroupByProduct (orderId) {
        let response = await this.$apollo.query({
          query: GET_ORDER_SKU_GROUPBY_PRODUCT,
          fetchPolicy: 'network-only',
          variables: { orderId: orderId },
        })
        if (response.data) {
          this.productArr = response.data.Product
          this.batch_loader = false
        }
      },
      getSupportPlanStatus (endDate) {
        if (moment(moment().format('YYYY-MM-DD')).isBefore(moment(endDate).format('YYYY-MM-DD')))
          return { expired: false, class: 'ActiveSupportPlan' }
        else
          return { expired: true, class: 'ExpiredSupportPlan' }
      },
      exportRetailSales (orderType) {
        window.open(`${Constants.api_url}partnerRetailSalesExport/${this.userObj.orgId}/${orderType}`, '_blank')
      },
    },
  }
  </script>
  <style scoped>
  .ActiveSupportPlan {
    border: 2px solid #00C714;
    border-radius: 5px;
  }
  
  .ActiveSupportPlanLabel {
    color: #00C714;
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .ExpiredSupportPlan {
    border: 2px solid #DE5454;
    border-radius: 5px;
  }
  
  .ExpiredSupportPlanLabel {
    color: #DE5454;
    font-size: 1.5rem;
    font-weight: bold;
  }
  </style>
  